import { render } from "./Edit.vue?vue&type=template&id=67e00187&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=67e00187&lang=scss&scoped=true"
import "./Edit.vue?vue&type=style&index=1&id=67e00187&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e00187"]])

export default __exports__